import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const TermsAndCondition = () => {

    const navigate = useNavigate();

    return (
        <div style={{ padding: '20px', color: '#A6A7A8' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
                <button className='back-button' onClick={() => navigate('/home')}>
                    <FiChevronLeft className='back-button-icon' />
                </button>
                <div style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 700, marginLeft: '20px' }}>FAQ</div>
            </div>
            <div>
                <ul className='mt-4'>
                    <li>
                        <p className='FAQ-Question'>What is the Bitcoin Premier League?</p>
                        <p className='paragraph'>The Bitcoin Premier League is an exciting event where users can answer three simple quiz questions for a chance to win exciting rewards and bonuses. Additionally, you can predict the winning team, On correct prediction you get bonus rewards. There's also a Weekly Stacker, where you can win big by making card or voucher transactions for 7 consecutive days.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Who can participate in the campaign?</p>
                        <p className='paragraph'>The campaign is open to all users with an active account on our platform.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>When does this campaign end?</p>
                        <p className='paragraph'>The Bitcoin Premier League campaign ends on 3rd June,2025 at 11:59Pm.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>How many questions are there in the daily quiz?</p>
                        <p className='paragraph'>Each day, there are three quiz questions. You get 30 seconds to answer each question.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>How many questions should I get correct to be eligible for reward?</p>
                        <p className='paragraph'>If you answer two or more questions correctly, you qualify to win exciting rewards.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Are there specific time limits to claim rewards from quiz?</p>
                        <p className='paragraph'>Yes, rewards must be claimed within 12 hours of completing the quiz.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Can rewards be accumulated or carried forward?</p>
                        <p className='paragraph'>No, rewards are specific to daily activities and must be redeemed within 24hours of receiving them.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Can I attempt the quiz more than once in a day?</p>
                        <p className='paragraph'>No, the quiz can only be attempted once per day.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>How do I earn the bonus rewards on card spends of ₹500 & above?</p>
                        <p className='paragraph'>Spend ₹500 using your GoSats card on eligible categories within 24 hours of getting the reward, and Bonus Sats will be credited to your account once the transaction is completed.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>How do I earn the bonus rewards on voucher purchases ₹500 & above?</p>
                        <p className='paragraph'>Spend ₹500 on a voucher within 24 hours of getting the reward, and bonus Sats will be credited to your account once the transaction is completed.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Can I make multiple transactions to reach the ₹500 milestone?</p>
                        <p className='paragraph'>No, cumulative spends will not count for the bonus reward.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Are there any blocked categories where my card spends will not be eligible for bonus reward or weekly streak?</p>
                        <p className='paragraph'>Transactions made in the following categories are not applicable for Sats Bonus Reward Bonus rewards: Bill/Utility Payments, Digital Wallet Loads, Real Estate Payments, Government services, Telecommunications, Insurance, Quasi Cash, Fuel Payments & Education.  </p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>I've spent ₹500 but the bonus rewards are not credited to my account?</p>
                        <p className='paragraph'>The bonus sats will be credited to all the eligible users once the transaction is completed, if you don't receive the rewards please do contact the in-app support or write to us "support@gosats.io"</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Can I make multiple voucher purchases to reach the ₹500 milestone?</p>
                        <p className='paragraph'>No, cumulative voucher purchases during the campaign period will not count.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>How do I claim my bonus reward on a SatsPay transaction?</p>
                        <p className='paragraph'>Simply spend ₹200 or more using SatsPay within 24 hours of receiving the reward and the bonus Sats will be credited to your account instantly after the transaction is completed.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>How do I claim my bonus reward on a BBPS transaction?</p>
                        <p className='paragraph'>Simply spend ₹200 or more using BBPS on the GoSats app within 24 hours of receiving the reward and the bonus Sats will be credited to your account instantly after the transaction is completed.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What is the weekly streak offer?</p>
                        <p className='paragraph'>Weekly stacker is where you need to make a card or voucher transaction of ₹200 or above for 7 consecutive days and get a chance to win up to 5000 Sats bonus.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What will happen to my streak if I miss any one day?</p>
                        <p className='paragraph'>Your purchase streak will reset on missing out any one day.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>How does the match prediction work?</p>
                        <p className='paragraph'>You can select the IPL team you support and if the prediction is correct you'll be able to claim your reward within 2 hours of the match end.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Until when can I make the prediction for the match?</p>
                        <p className='paragraph'>You can make your prediction until the match starts. Post that predictions won't be accepted.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>When'll the rewards for correct prediction be distributed?</p>
                        <p className='paragraph'>The rewards can be claimed for 2 hours after the match has ended.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What will happen to my prediction if there is a tie in the match?</p>
                        <p className='paragraph'>All predictions will be deemed null and void, and no rewards will be distributed.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What if I don't receive my rewards?</p>
                        <p className='paragraph'>Please contact us via the In-app support or write to us at "support@gosats.io" from your registered mail Id.</p>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default TermsAndCondition;